import React from 'react';
import styled from 'styled-components';

import type { IFormDataOptions } from '@/types/forms';

import { Input } from './Input';
import { formData } from '@/helpers';
import { InputDescription } from './components';

interface DateTimeInputProps {
  dateName: string;
  timeName: string;
  formDataOptions: IFormDataOptions;
  label?: string;
  required?: boolean;
  description?: string;
}

const DateTimeInput = (props: DateTimeInputProps): React.ReactElement => {
  return (
    <fieldset>
      <DateTimeContainer>
        <Input
          name={props.dateName}
          type="date"
          label={props.label}
          required={props.required}
          {...formData(props.dateName, props.formDataOptions)}
        />
        <Input
          name={props.timeName}
          type="time"
          required={props.required}
          {...formData(props.timeName, props.formDataOptions)}
        />
      </DateTimeContainer>
      {props.description && <InputDescription>{props.description}</InputDescription>}
    </fieldset>
  );
};

export { DateTimeInput };

const DateTimeContainer = styled.div`
  display: flex;
  column-gap: 24px;
  align-items: flex-end;
  flex-wrap: wrap;

  fieldset {
    flex: 1;
    min-width: 200px;
  }
`;
